export default {
  header: 'Kosten',
  total: 'Totale kosten',
  perLiter: 'Kosten per liter',
  perBottle075: 'Kosten per fles (0.75)',
  perBottle033: 'Kosten per fles (0.33)',
  perCan033: 'Kosten per blik (0.33)',
};
